/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const CmpAttachbutton = ({ className = "", state = "default", onClick = () => {} }) => {
  return (
    <svg
      className={`cmp-attachbutton ${state} ${className}`}
      fill="none"
      height="36"
      viewBox="0 0 36 36"
      width="36"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      {/* Background rectangle for hover */}
      <rect 
        x="0" y="0" 
        width="36" height="36" 
        rx="8" ry="8" 
        fill="currentColor" 
        fillOpacity="0"
        className="hover-bg"
      />
      {/* Classic diagonal paperclip - centered in 36x36 */}
      <path
        d="M25.5 15L15 25.5a4.95 4.95 0 01-7-7L18.5 8a3.3 3.3 0 014.67 4.67L12.83 23a1.65 1.65 0 01-2.33-2.33L20 11.17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};

CmpAttachbutton.propTypes = {
  state: PropTypes.oneOf(["default", "hover", "pressed"]),
  onClick: PropTypes.func,
};
